import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SetupService } from 'src/app/services/setup.service';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ManagerService } from 'src/app/services/manager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TellerService } from 'src/app/services/teller.service';
import { send } from 'q';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit {
  @ViewChild('alertForm') @ViewChild('singleForm') public any: NgForm;
  send: any; sing: any; date: any; save: any; edit: boolean;
  cust: any[] = []; staff: any[] = []; get: any; res: any;
  constructor(private _set: SetupService, private _api: ManagerService,
    private _get: TellerService, private use: NavComponent) { }

  ngOnInit() {
    this.date = this.use.date;
    this.formReset();
    this.getAllCustomers();
  }

  getAllCustomers() {
    this._api.getCustomers().subscribe((data: any) => {
      this.cust = data.data; this.getAllC();
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Customer List Fail', 'Unable to Fetch Customer List');
    });
    // this._get.getEmployees().subscribe((data: any) => {
    //   this.staff = data.data; this.getAllS();
    // }, (err: HttpErrorResponse) => {
    //   this.use.showMsg('error', 'Staff List Fail', 'Unable to Fetch Employee List');
    // });
  }

  postBoardcast() {
    this._api.postSms(this.send).subscribe((data: any) => {
      // this.res = data;
      this.use.showMsg('success', 'Sms Sented', 'Sms Status' + data.response);
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Sending Fail', 'Unable to Send Sms');
    });
  }

  postSingle() {
    this._set.postSmslog(this.sing).subscribe((data: any) => {
      // this.res = data;
      this.use.showMsg('success', 'Sms Sented', 'Sms Status' + data.response);
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Sending Fail', 'Unable to Send Sms');
    });
  }

  postSms() {
    if (this.save.alertid > 0) {
      this._api.putAlert(this.save.alertid, this.save).subscribe((data: any) => {
        this.send = data; this.formReset();
        this.use.showMsg('success', 'Alert Updated', 'Alert Has been Updated Successfully');
      }, (err: HttpErrorResponse) => {
        this.use.showMsg('error', 'Alert Fail', 'Unable to Update Sms Alert');
      });
    } else {
      this._api.postAlert(this.save).subscribe((data: any) => {
        this.send = data; this.formReset();
        this.use.showMsg('success', 'Alert Saved', 'Alert Has been Saved Successfully');
      }, (err: HttpErrorResponse) => {
        this.use.showMsg('error', 'Alert Fail', 'Unable to Save Sms Alert');
      });
    }
  }

  getSms(value) {
    this._api.getAlertByType(value).subscribe((data: any) => {
      this.save = data;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Fetching Fail', 'No Saved Aler message for ' + value);
      // this.formReset();
    });
  }

  getCust(id) {
    
    this._api.getCustomer(id).subscribe((data: any) => {
      this.sing.mobile = data.mobile;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Fetching Fail', 'Unable to Get Customer Mobile');
    });
  }

  getAll(value) {
    this.send.mobile = '';
    this.send.count = 0;
    if (value === 'Staff') {
      this.getAllS();
    } else if (value === 'Customer') {
      this.getAllC();
    } else {
      this.getAllC(); this.getAllS();
    }
  }

  getAllC() {
    this.cust.forEach((e: any) => {
      if (e.mobile.length > 9) {
        this.send.mobile += e.mobile + ',';
        this.send.count += 1;
      }
    });
  }

  getAllS() {
    this.staff.forEach((e: any) => {
      if (e.mobile.length > 9) {
        this.send.mobile += e.mobile + ',';
        this.send.count += 1;
      }
    });
  }

  formReset(form?: NgForm) {
    if (form != null) {
      form.reset();
    } else {
      this.send = { mobile: '', message: '', option: 'All', count: 0,
        userid: this.use.active.id, merchantid: this.use.active.merchantid, date: new Date() };
      this.sing = { customerid: '', mobile: '', message: '', option: '',
        userid: this.use.active.id, merchantid: this.use.active.merchantid, date: new Date() };
      this.save = {
        alertid: 0, type: '', message: '', name: false, auto: true,
        userid: this.use.active.id, merchantid: this.use.active.merchantid, date: new Date()
      };
    }
  }

}
